class MedicoPanelItem extends React.Component {
  constructor() {
    super();

    this.state = {
        eventKey: Math.random(),
        titleColorClass: 'titulo-beneficio-item',
        icon: <i className="fa fa-chevron-circle-down"></i>,
        isActive: true
    } 
  }
  
  changePanelStatus(e)
  {
    if(this.state.titleColorClass == 'titulo-beneficio-item'){
      this.setState({ titleColorClass: 'titulo-beneficio-item-seleccionado', icon: <i className="fa fa-chevron-circle-up"></i> })
    } else {
      this.setState({ titleColorClass: 'titulo-beneficio-item', icon: <i className="fa fa-chevron-circle-down"></i> })
    }
  }

  render() {
    return (
      <div className="mi-medico">
        <div className="row">
          <div className="col-sm-5">
            <h5>Médico</h5>
            <h4>Dr. {this.props.item.NombreMedico}</h4>
          </div>
          <div className="col-sm-2">
            <h5>{this.props.item.Especialidad}</h5>
          </div>
          <div className="col-sm-3">
            { this.props.configurations['BotonCambiarMedicoPersonalCSVisibleBool'] ? ( 
              <Button onClick={ () => window.location.href = this.props.configurations['BotonCambiarMedicoPersonalCSDescripcionText'] }  className="btn btn-primary change-doctor">{this.props.configurations['BotonCambiarMedicoPersonal']}</Button>
            ) : ( null ) }
          </div>
          <div className="col-sm-2">
            { this.props.configurations['BotonAgendarCitaMedicoPersonalCSVisibleBool'] ? ( 
              <Button onClick={ () => window.location.href = this.props.configurations['BotonAgendarCitaMedicoPersonalCSDescripcionText'] }  className="btn btn-primary">{this.props.configurations['BotonAgendarCitaMedicoPersonal']}</Button>
            ) : ( null ) }
          </div>
        </div>
        <hr className="hr-line-div-elem" />
      </div>
    );
  }
}

/******************** BUILD ********************/
const Panel = ReactBootstrap.Panel;
const Button = ReactBootstrap.Button;
/******************** BUILD ********************/

export default MedicoPanelItem;



// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/miSedeMedicoPersonal/src/components/medicoPanelItem.js